import './banner.scss';

import {
      INTERPOLATION_REGEX,
      MEDIAQUERY_XSMALL,
      MEDIAQUERY_SMALL,
      MEDIAQUERY_MEDIUM,
      MEDIAQUERY_LARGE,
      MEDIAQUERY_XLARGE,
    } from '../../core/constants';
import { getSelectedVehicle } from '../../core/selectors/vehicles';
riot.tag2('offers-banner', '<banner background-color="#ddd" background-image="{size ? banner[\'backgroundImageURL\' + size] : \'\'}" button-text="{banner.CTA}" description="{banner.shortDescription}" each="{banner in getLabel(\'banners\')}" target="_self" title="{banner.shortDescription}" banner-title="{vehicle ? getText(banner.title) : getTextWithoutToken(banner.title)}" url="{vehicle ? getText(banner.CTABaseURL.url, true) : getTextWithoutQuery(banner.CTABaseURL.url)}" tracking-json="{this.parent.trackingJson}"> </banner>', '', 'if="{banners.length}"', function(opts) {

    const self = this;

    self.trackingJson = require('../../data/tracking-data').default.offersBanner;

    self.mixin('bus');
    self.mixin('redux');
    self.subscribe(getSelectedVehicle);

    const breakpoints = [
      {
        matchMedia: window.matchMedia(MEDIAQUERY_XSMALL),
        size: 'XSmall',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_SMALL),
        size: 'Small',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_MEDIUM),
        size: 'Medium',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_LARGE),
        size: 'Large',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_XLARGE),
        size: 'XLarge',
      },
    ];

    breakpoints.forEach((breakpoint) => {
      if (breakpoint.matchMedia.matches) {
        self.size = breakpoint.size;
        self.update();
      }

      breakpoint.matchMedia.addListener((mediaQuery) => {
        if (mediaQuery.matches) {
          self.size = breakpoint.size;
          self.update();
        }
      });
    });

    function buttonClick(data) {
      if (data.url) {
        window.open(data.url, data.target || '_blank');
      }
    }

    function getText(name, urlize) {
      const replacements = name.match(INTERPOLATION_REGEX);

      if (replacements) {
        replacements.forEach((match) => {
          name = name.replace(match, self.vehicle[match.slice(3, -3)]);
        });
      }

      if (urlize) {
        name.replace(' ', '-');
      }

      return name;
    }

    function getTextWithoutToken(name) {
      const replacements = name.match(INTERPOLATION_REGEX);

      if (replacements) {
        replacements.forEach((match) => {
          name = name.replace(match, '');
        });
      }

      return name;
    }

    function getTextWithoutQuery(url) {
      return url.split('?')[0];
    }

    self.getText = getText;
    self.getTextWithoutToken = getTextWithoutToken;
    self.getTextWithoutQuery = getTextWithoutQuery;

    self.bus.on(self.bus.EVENTS.BANNER.BUTTON_CLICK, buttonClick);
});